import CookieConsent from 'react-cookie-consent';
import { isMobileVersion } from '../../lib/soar-helper';
import Analytics from '../../lib/user-analytics';

export const CustomCookieConsent = () => {
    const onAccept = () => {
        Analytics.Event('Cookie Consent', 'Clicked Accept');
    };
    return (
        <CookieConsent
            debug={false}
            style={{
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                border: 'none',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                maxWidth: isMobileVersion ? 'auto' : '70%',
                width: isMobileVersion ? 'auto' : '100%',
                padding: '0',
                borderBox: '0',
                marginBottom: isMobileVersion ? '110px' : '20px',
                marginLeft: isMobileVersion ? '10px' : '15%',
                marginRight: isMobileVersion ? '10px' : '15%',
                position: 'fixed',
                bottom: '20px',
                zIndex: 99999,
            }}
            contentStyle={{
                color: '#fff',
                alignItems: 'center',
                justifyContent: 'center',
                margin: isMobileVersion ? '10px' : '15px 15px 15px 20px',
            }}
            buttonText="ACCEPT"
            buttonStyle={{
                color: '#000',
                background: '#EED926',
                borderRadius: '6px',
                marginRight: isMobileVersion ? '0px' : '20px',
                padding: '3px 20px',
                margin: isMobileVersion && 'auto 10px 10px 10px',
                width: isMobileVersion && '90vw',
            }}
            hideOnAccept={true}
            onAccept={onAccept}
        >
            We use cookies to provide the best experience for our users. To find out more please visit our full&nbsp;
            <a href="/privacy" style={{ color: '#EED926' }}>
                &nbsp;Privacy Policy
            </a>
            .
        </CookieConsent>
    );
};
